import React from 'react';

import { getTaskStatus } from '../../../globals';
import { TaskStatusBadge } from '../../common/task-status-badge';

interface IActivityPropertyTaskStatus {
  value?: string | null;
}

// ActivityProperty TaskStatus = 9
export const ActivityPropertyTaskStatus = ({
  value,
}: IActivityPropertyTaskStatus) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsedVal = parseInt(value, 10);
  if (isNaN(parsedVal)) {
    // we tried, not a number, not much more we can do
    return null;
  }
  return <TaskStatusBadge status={getTaskStatus(parsedVal)} />;
};
